// Vendor
import { defaultIconColor } from './constants';
import { IconProps } from './types';

export const PhoneIcon = ({ color = defaultIconColor, ...props }: IconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.5174 20.5449L23.6986 19.1851C22.5034 18.6089 21.5468 18.941 20.8229 19.75L19.0325 21.7403C18.6794 22.1345 18.0944 22.2185 17.6445 21.9398C16.1177 20.9783 14.7051 19.8466 13.4337 18.5663C12.1534 17.295 11.0216 15.8823 10.0602 14.3555C9.78145 13.9056 9.86552 13.3206 10.2597 12.9675L12.2499 11.1771C13.059 10.4532 13.3911 9.49656 12.8149 8.30145L11.4551 5.48254C10.7114 3.9383 9.67239 3.59195 8.12812 4.48336C7.13394 5.10413 6.22374 5.85021 5.41992 6.70321C2.40807 9.81163 4.33268 16.6927 9.81998 22.18C15.3072 27.6673 22.1883 29.5919 25.2968 26.5801C26.1498 25.7762 26.8959 24.8661 27.5167 23.8719C28.4081 22.3276 28.0617 21.2886 26.5174 20.5449Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChatIcon = ({ color = defaultIconColor, ...props }: IconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.1538 23V22.5C12.0143 22.5 11.8811 22.5583 11.7864 22.6609L12.1538 23ZM8 27.5H7.5C7.5 27.7059 7.62619 27.8907 7.81793 27.9657C8.00967 28.0406 8.22776 27.9904 8.3674 27.8391L8 27.5ZM8 23H8.5C8.5 22.7239 8.27614 22.5 8 22.5V23ZM6 5.5C3.51472 5.5 1.5 7.51472 1.5 10H2.5C2.5 8.067 4.067 6.5 6 6.5V5.5ZM26 5.5H6V6.5H26V5.5ZM30.5 10C30.5 7.51472 28.4853 5.5 26 5.5V6.5C27.933 6.5 29.5 8.067 29.5 10H30.5ZM30.5 19V10H29.5V19H30.5ZM26 23.5C28.4853 23.5 30.5 21.4853 30.5 19H29.5C29.5 20.933 27.933 22.5 26 22.5V23.5ZM12.1538 23.5H26V22.5H12.1538V23.5ZM8.3674 27.8391L12.5212 23.3391L11.7864 22.6609L7.6326 27.1609L8.3674 27.8391ZM7.5 23V27.5H8.5V23H7.5ZM6 23.5H8V22.5H6V23.5ZM1.5 19C1.5 21.4853 3.51472 23.5 6 23.5V22.5C4.067 22.5 2.5 20.933 2.5 19H1.5ZM1.5 10V19H2.5V10H1.5ZM9.54286 13.5C10.0869 13.5 10.5 13.9234 10.5 14.5429H11.5C11.5 13.448 10.7131 12.5 9.54286 12.5V13.5ZM8.5 14.5429C8.5 13.9619 8.96186 13.5 9.54286 13.5V12.5C8.40957 12.5 7.5 13.4096 7.5 14.5429H8.5ZM9.54286 15.5C8.94319 15.5 8.5 15.0198 8.5 14.5429H7.5C7.5 15.6087 8.42824 16.5 9.54286 16.5V15.5ZM10.5 14.5429C10.5 15.0576 10.1048 15.5 9.54286 15.5V16.5C10.6952 16.5 11.5 15.571 11.5 14.5429H10.5ZM16.0429 13.5C16.5198 13.5 17 13.9432 17 14.5429H18C18 13.4282 17.1087 12.5 16.0429 12.5V13.5ZM15 14.5429C15 13.9619 15.4619 13.5 16.0429 13.5V12.5C14.9096 12.5 14 13.4096 14 14.5429H15ZM16.0429 15.5C15.4432 15.5 15 15.0198 15 14.5429H14C14 15.6087 14.9282 16.5 16.0429 16.5V15.5ZM17 14.5429C17 15.0381 16.5381 15.5 16.0429 15.5V16.5C17.0904 16.5 18 15.5904 18 14.5429H17ZM24.5 14.5429C24.5 13.4096 23.5904 12.5 22.4571 12.5V13.5C23.0381 13.5 23.5 13.9619 23.5 14.5429H24.5ZM22.4571 16.5C23.5718 16.5 24.5 15.6087 24.5 14.5429H23.5C23.5 15.0198 23.0568 15.5 22.4571 15.5V16.5ZM20.5 14.5429C20.5 15.5904 21.4096 16.5 22.4571 16.5V15.5C21.9619 15.5 21.5 15.0381 21.5 14.5429H20.5ZM22.4571 12.5C21.3913 12.5 20.5 13.4282 20.5 14.5429H21.5C21.5 13.9432 21.9802 13.5 22.4571 13.5V12.5Z"
      fill={color}
    />
  </svg>
);

export const HourglassIcon = ({ color = defaultIconColor, ...props }: IconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.0338 16L17.605 15.7428C17.51 15.9011 17.51 16.0989 17.605 16.2572L18.0338 16ZM24.3251 5.5145L24.7538 5.77174V5.77174L24.3251 5.5145ZM8.14246 5.5145L7.71372 5.77174V5.77174L8.14246 5.5145ZM14.4338 16L14.8625 16.2572C14.9575 16.0989 14.9575 15.9011 14.8625 15.7428L14.4338 16ZM8.14246 26.4855L7.71372 26.2283H7.71372L8.14246 26.4855ZM24.3251 26.4855L24.7538 26.2283L24.3251 26.4855ZM18.4625 16.2572L24.7538 5.77174L23.8963 5.25725L17.605 15.7428L18.4625 16.2572ZM24.7538 5.77174C25.3537 4.77196 24.6335 3.5 23.4676 3.5V4.5C23.8562 4.5 24.0963 4.92399 23.8963 5.25725L24.7538 5.77174ZM23.4676 3.5H8.99996V4.5H23.4676V3.5ZM8.99996 3.5C7.83401 3.5 7.11385 4.77196 7.71372 5.77174L8.57121 5.25725C8.37125 4.92399 8.61131 4.5 8.99996 4.5V3.5ZM7.71372 5.77174L14.005 16.2572L14.8625 15.7428L8.57121 5.25725L7.71372 5.77174ZM8.57121 26.7428L14.8625 16.2572L14.005 15.7428L7.71372 26.2283L8.57121 26.7428ZM8.99996 27.5C8.61131 27.5 8.37125 27.076 8.57121 26.7428L7.71372 26.2283C7.11385 27.228 7.83401 28.5 8.99996 28.5V27.5ZM23.4676 27.5H8.99996V28.5H23.4676V27.5ZM23.8963 26.7428C24.0963 27.076 23.8562 27.5 23.4676 27.5V28.5C24.6335 28.5 25.3537 27.228 24.7538 26.2283L23.8963 26.7428ZM17.605 16.2572L23.8963 26.7428L24.7538 26.2283L18.4625 15.7428L17.605 16.2572Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4458 14.6608C16.3479 14.8175 16.1197 14.8175 16.0218 14.6608L13.9728 11.3825C13.8688 11.216 13.9885 11 14.1848 11H18.2827C18.4791 11 18.5988 11.216 18.4947 11.3825L16.4458 14.6608ZM15.2544 21C14.9281 21 14.6223 21.1592 14.4352 21.4265L11.5091 25.6066C11.3931 25.7723 11.5117 26 11.7139 26H20.7536C20.9559 26 21.0744 25.7723 20.9584 25.6066L18.0323 21.4265C17.8452 21.1592 17.5394 21 17.2131 21H15.2544Z"
      fill={color}
    />
  </svg>
);

export const HelpQuestionMarkIcon = ({ color = defaultIconColor, ...props }: IconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 20V16C18.2091 16 20 14.2091 20 12C20 9.79086 18.2091 8 16 8C13.7909 8 12 9.79086 12 12M16 25C16.5523 25 17 24.5523 17 24C17 23.4477 16.5523 23 16 23C15.4477 23 15 23.4477 15 24C15 24.5523 15.4477 25 16 25ZM16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EmailIcon = ({ color = defaultIconColor, ...props }: IconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 6L28 6M4 6C3.17157 6 2.5 6.67157 2.5 7.5V24.5C2.5 25.3284 3.17157 26 4 26H28C28.8284 26 29.5 25.3284 29.5 24.5V7.5C29.5 6.67157 28.8284 6 28 6M4 6L16 16.5L28 6"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
